import {
    lazyCreateOrUpdateOptionsForFeature,
    OwsOptionsFeatureType,
    lazyGetServerOptionsForFeature,
    getOptionsForFeature,
} from 'owa-outlook-service-options';
import type { OutlookSpacesOptions } from 'owa-outlook-service-option-store';

export default async function updateSpacesOptions(options: Partial<OutlookSpacesOptions>) {
    const getServerOptionsForFeature = await lazyGetServerOptionsForFeature.import();
    const serverOptions =
        (getServerOptionsForFeature &&
            (await getServerOptionsForFeature<OutlookSpacesOptions>(
                OwsOptionsFeatureType.OutlookSpaces
            ))) ||
        getOptionsForFeature<OutlookSpacesOptions>(OwsOptionsFeatureType.OutlookSpaces);
    const mergedOptions: OutlookSpacesOptions = {
        ...serverOptions,
        ...options,
    };
    lazyCreateOrUpdateOptionsForFeature.importAndExecute(
        OwsOptionsFeatureType.OutlookSpaces,
        mergedOptions
    );
}
